'use strict';

var BaseGroup = require('config/Group');
var i18n = require('i18next');
var RenderPositions = require('config/RenderPositions');

/**
 * "Static Host Mapping" configuration group.
 */
module.exports = BaseGroup.extend({
  actionList: [
    {
      name: 'staticHostMapping',
      position: RenderPositions.full,
      required: true,
      renderTitle: false,
      renderStatic: true,
      doubleWide: false,
    },
  ],

  isConnectivityDisrupted: function(type, target) {
    return true;
  },

  /**
   * @return {Boolean}
   */
  isRequired: function() {
    return true;
  },

  /**
   * @return {String}
   */
  title: function() {
    return i18n.t('groups.staticHostMapping');
  },

  /**
   * Overridden to prevent base Group class from trying to
   * combine multiple DNS forwarding rules into one
   */
  shouldMergeTasks: false,
});
